module.exports = __webpack_public_path__ + "static/media/matrix.f7b7b7d7.png";